/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import useScrollToTop from "../../hooks/useScrollToTop";
import useWindowWidth from "../../hooks/useWindowWidth";

import Selects from "../../components/Selects";
import {
  MoonIcon,
  CalendarDetailIcon,
  LocationDetailIcon,
} from "../../components/icons";

const SportsPackagesDetailsLoader = () => {
  const width = useWindowWidth();

  // Scroll to top
  useScrollToTop();

  return (
    <section className="sportDetails">
      <div className="sportDetails__image triangle right"></div>

      <div className="sportDetails__content">
        {width < 992 && (
          <div className="sportDetails__content__selects">
            <Selects />
          </div>
        )}

        <div className="sportDetails__content__header">
          <h1>Cargando</h1>
          <p>...</p>
        </div>

        <div className="sportDetails__content__cards">
          <div className="sportDetails__content__cards-time">
            <p>
              <CalendarDetailIcon /> Fechas
            </p>

            <p>
              <MoonIcon /> noches
            </p>

            <p>
              <LocationDetailIcon /> Ubicacion
            </p>
          </div>
          <div className="sportDetails__content__cards-price">
            <p>Desde</p>
            <h3>
              <span></span> 0
            </h3>
            {/* <Link to="/">Consultar</Link> */}
          </div>
        </div>
      </div>

      <div className="sportDetails__description">
        <h3>Descripción</h3>

        <ul></ul>
      </div>

      <div className="sportDetails__legals">
        <div className="sportDetails__legals__container">
          <small>
            <b>Políticas y Condiciones</b> <br />
          </small>
          <small>
            Los productos adquiridos dentro de un paquete se encuentran sujetos
            a las políticas del mismo. El paquete tiene un seguro de viaje con
            cancelación Any Reason y realiza una devolución con un tope de
            reintegro, detallado en la cobertura de tu seguro. La cancelación
            any reason es válida: Para paquetes fuera de Argentina. Avisando de
            la cancelación 48 hs antes de viajar y solo si la póliza del seguro
            se encuentra vigente. Solo si sos menor de 75 años. Comprando el
            paquete con una antelación mínima de 15 días previos a la fecha de
            inicio del viaje. El vuelo y el hotel incluidos en el paquete no
            tienen cambios ni devoluciones. Todas las reservas de vuelos están
            sujetas a reprogramaciones y/o cancelaciones por parte de la
            aerolínea.
          </small>
        </div>
      </div>
    </section>
  );
};

export default SportsPackagesDetailsLoader;
